import { DateUtilService } from '../date-utils';
import { Component, OnInit } from '@angular/core';
import { WebapiService } from '../webapi.service';
import { Router,ActivatedRoute } from '@angular/router';
import * as FileSaver from 'file-saver';
import { PreloaderService } from '../preloader.service';

@Component({
  selector: 'app-client-mis',
  templateUrl: './client-mis.component.html',
  styleUrls: ['./client-mis.component.scss']
})
export class ClientMisComponent implements OnInit {
  processList: any = [];
  filterData: any = {
    date: '',
    fromDay: '',
    fromMonth: '',
    fromYear: '',
    toDay: '',
    toMonth: '',
    toYear: '',
    from: '',
    to: '',
    clientId: '',
    process: '',
    color: '',
    status: '',
    checkName: '',
    checkStatus: ''
  };
  checkList: any = [];
  responseData: any;
  clickedData: any = [];
  reportUrl: any;
  processListSelect: any = [];
  s3Url: any = "";

  // Arrays for select options
  days: number[] = Array.from({length: 31}, (_, i) => i + 1);
  months: any[] = [
    { value: 1, name: 'January' },
    { value: 2, name: 'February' },
    { value: 3, name: 'March' },
    { value: 4, name: 'April' },
    { value: 5, name: 'May' },
    { value: 6, name: 'June' },
    { value: 7, name: 'July' },
    { value: 8, name: 'August' },
    { value: 9, name: 'September' },
    { value: 10, name: 'October' },
    { value: 11, name: 'November' },
    { value: 12, name: 'December' }
  ];
  years: number[] = Array.from({length: 10}, (_, i) => new Date().getFullYear() - i); // Last 10 years

  constructor(public dateUtil: DateUtilService, private webapiservice: WebapiService,private router:Router,private spinner:PreloaderService) {
    this.reportUrl = this.webapiservice.reportUrl;
    this.s3Url = this.webapiservice.s3Url;
  }

  ngOnInit(): void {
    let clientId = sessionStorage.getItem('loginId');
    this.filterData.clientId = clientId;
    this.getProcessByClient(clientId);


  }

  private formatDateString(day: string, month: string, year: string): string | null {
    if (day && month && year) {
      const paddedDay = day.padStart(2, '0');
      const paddedMonth = month.padStart(2, '0');
      return `${year}-${paddedMonth}-${paddedDay}`;
    }
    return null;
  }

  getCount(status: string, color: string): number {
    const key = `${status.toLowerCase()}${color}Count`;
    return this.responseData?.[key] ?? 0; // Return 0 if the count is undefined
  }

  getCheckCount(checkName: string, status: string): number {
    // Safely navigate through responseData and return the appropriate count or 0 if not found
    return this.responseData?.checknameCounts?.[checkName]?.[status] ?? 0;
  }

  getProcessByClient(id:any){
    this.webapiservice.getUserById(id).subscribe((res:any)=>{
      //  console.log(res);
      if(res.user){
        this.processListSelect = res?.user?.processList;
        this.processList = res?.user?.processList;
        this.filterData.process = res?.user?.processList[0]?.process;
        this.onFilterData(this.filterData);
      }
      else{
        this.onFilterData(this.filterData);
        this.processList = [];
       }
    });
  }

  getProcessChecks(name:any){
  //  console.log(e.target.value,'--');
   this.processList = this.processListSelect.filter(prd => prd.process == name);
   console.log(this.processList,'--');

  }

  onFilterData(data:any){
    const fromDate = this.formatDateString(
      this.filterData.fromDay,
      this.filterData.fromMonth,
      this.filterData.fromYear
    );
  
    const toDate = this.formatDateString(
      this.filterData.toDay,
      this.filterData.toMonth,
      this.filterData.toYear
    );

    if (fromDate && toDate) {
      this.filterData.from = fromDate;
      this.filterData.to = toDate;
    }
    const from = new Date(fromDate);
    const to = new Date(toDate);
  
    if (from > to) {
      alert('From Date cannot be after To Date.');
      return;
    }

    this.spinner.show();
    this.getProcessChecks(data.process);
    this.webapiservice.getClientMisCount(data).subscribe((res:any)=>{
       if(res.status == 'ok'){
        this.spinner.hide();
   this.responseData = res?.data;
   this.getClientDataAll(data);
       }
       else{
        this.responseData = {};
        this.spinner.hide();
       }
    });
  }

  getClientDataAll(data:any){
    this.webapiservice.getMisClientDataAll(data).subscribe((res:any)=>{
      if(res.status == 'ok'){
       this.clickedData = res?.data;
      }
      else{
       this.clickedData = [];
      }
   });
  }
  updateStatus(e:any,id:any){
    let conf = confirm('Are you sure you want to update status??');
    if(conf){
      let val = {
        status: e.target.value,
        appId:id
       }
       this.webapiservice.updateAppStatus(val).subscribe((res:any)=>{
        if(res.status == 'ok'){
      alert(res.msg);
      location.reload();
        }
        else{
alert('Error updating Status..')
        }
     });
    }
  }

  getApplicationByClick(count:any,color:any,status:any){
    if(count > 0){
    this.filterData.color = color;
    this.filterData.status = status;
    this.webapiservice.getClientMisData(this.filterData).subscribe((res:any)=>{
     console.log(res);
     if(res.status == 'ok'){
 this.clickedData = res.data;
     }
     else{
      this.responseData = {}
     }
    });
    }
    else{
     alert('Count is less than 1');
    }

   }

   getApplicationByClickV2(count:any,chkName:any,chkStatus:any){
    if(count > 0){
    this.filterData.checkName = chkName;
    this.filterData.checkStatus = chkStatus;
    this.webapiservice.getClientMisChecksData(this.filterData).subscribe((res:any)=>{
     console.log(res);
     if(res.status == 'ok'){
 this.clickedData = res.data;
     }
     else{
      this.responseData = {}
     }
    });
    }
    else{
     alert('Count is less than 1');
    }

   }

   getExcelDownload(data:any){
    data.exportType = 'check';
    this.webapiservice.exportMisReport(data).subscribe((res: any) => {
      console.log(res);
    const blob = new Blob([res], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
     FileSaver.saveAs(blob, 'MisReport.xlsx');
    });
   }




}
